import React from 'react';
import styles from "./styles.module.css";
import { useNavigate, useLocation } from 'react-router-dom';

export default function ChatNav() {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    // Menu Items
    const menu = [
        {
            label: "Matches",
            path: "/user/chat/matches",
            isActive: pathname.startsWith("/user/chat/matches")
        },
        {
            label: "Likes",
            path: "/user/chat/likes/received",
            isActive: pathname.startsWith("/user/chat/likes")
        },
        // {
        //     label: "Requests",
        //     path: "/user/chat/requests/received",
        //     isActive: pathname.startsWith("/user/chat/requests")
        // },
        {
            label: "Other",
            path: "/user/chat/others/skipped",
            isActive: pathname.startsWith("/user/chat/others")
        },
    ];

    return (
        <div className={styles.nav}>
            <ul>
                {menu.map((item, index) => (
                    <li
                        key={index}
                        className={item.isActive ? styles.active : ""}
                        onClick={(e) => {e.preventDefault(); navigate(item.path)}}
                    >
                        {item.label}
                    </li>
                ))}
            </ul>
        </div>
    );
}
